

export const settingsTranslationTH = {
  settings: {
    "title": "การตั้งค่า",
    'preferences': 'การตั้งค่า',
    "account": "บัญชี"
  }
}